module.exports = __webpack_public_path__ + "assets/briefcase-a23cca534f61bb316232644eb40e1b28.svg";